import { cva } from 'class-variance-authority'
import { FC } from 'react'
import { TextProps } from './text.types'

const TextStyles = cva('not-italic font-montserrat m-0', {
  variants: {
    type: {
      title: 'font-semibold text-2xl text-grey-95 md:text-[28px] lg:text-[28px]',
      sectionTitle:
        'font-semibold text-2xl text-dark-primary md:text-[28px] lg:text-[28px]',
      subtitle:
        'font-medium text-xl text-dark-gray md:text-[21px] lg:text-[21px]',
      body: 'font-normal text-base text-dark-gray md:text-sm lg:text-sm',
      button: 'font-medium text-base text-dark-gray md:text-sm lg:text-sm',
      link: 'font-medium text-base text-blue-50 underline md:text-sm lg:text-sm',
      placeholder:
        'italic text-base font-normal text-grey-50 md:text-sm lg:text-sm',
      columnName: 'text-xs font-normal text-grey-50',
      rowSubTitle: 'text-xs font-normal text-grey-50',
      header:
        'font-semibold text-2xl text-dark-primary md:text-[28px] lg:text-[28px]',
        sharingUrlHeader:
        'font-semibold text-2xl text-grey-95 md:text-[28px] lg:text-[28px]',
      sharingUrlTitle:
      'font-medium text-xl tet-grey-95 md:text-[21px] lg:text-[21px]',
      label:'hover:text-blue-50'
    },
  },
})

export const Text: FC<TextProps> = ({ label, type = 'body', preTag = false }) => {
  return (
    <div>
      {preTag ? (
        <pre
          className={`${TextStyles({ type })} whitespace-pre-line break-all`}
        >
          {label}
        </pre>
      ) : (
        <p className={`${TextStyles({ type })}`}>{label}</p>
      )}
    </div>
  )
}
